import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '../../../core/design-system/components/Icon';
import { ROUTES } from '../../../core/constants/routes';
import { useUnreadNotificationsCount } from '../../../features/notifications/hooks/useNotifications';
import './styles.css';

const MainMenu = ({ compact = false, onNavigate }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const location = useLocation();
  const unreadCount = useUnreadNotificationsCount();

  const handleNavigation = (route) => {
    window.scrollTo(0, 0);
    navigate(route);
    onNavigate?.(); // Fermer le drawer après navigation
  };

  const isActive = (route) => {
    if (route === ROUTES.DASHBOARD_LLM) {
      return location.pathname === ROUTES.DASHBOARD_LLM || location.pathname === '/dashboard/llm';
    }
    if (route === ROUTES.DASHBOARD_FEED) {
      return location.pathname === ROUTES.DASHBOARD_FEED || location.pathname === '/dashboard/feed';
    }
    return location.pathname.startsWith(route);
  };

  const MenuItem = ({ icon, label, route, badge }) => {
    const active = isActive(route);
    
    return (
      <button
        className={`menu-item ${active ? 'menu-item-active' : ''} ${compact ? 'menu-item-compact' : ''}`}
        onClick={() => handleNavigation(route)}
        aria-label={label}
        title={compact ? label : undefined}
      >
        <div className="menu-item-icon">
          <Icon name={icon} size={compact ? 20 : 24} variant={active ? 'filled' : 'outline'} />
          {badge > 0 && (
            <span className="menu-item-badge">{badge > 99 ? '99+' : badge}</span>
          )}
        </div>
        {!compact && <span className="menu-item-label">{label}</span>}
      </button>
    );
  };

  return (
    <nav className={`main-menu ${compact ? 'main-menu-compact' : 'main-menu-full'}`}>
      {/* Navigation principale */}
      <div className={compact ? 'menu-group-compact' : 'menu-group'}>
        <MenuItem
          icon="robot"
          label={t('menu.llm')}
          route={ROUTES.DASHBOARD_LLM}
        />
        <MenuItem
          icon="home"
          label={t('menu.feed')}
          route={ROUTES.DASHBOARD_FEED}
        />
        <MenuItem
          icon="calendar-plus"
          label={t('menu.my_activities')}
          route={ROUTES.DASHBOARD_ACTIVITIES}
        />
        <MenuItem
          icon="bell"
          label={t('menu.notifications')}
          route={`${ROUTES.DASHBOARD}/notifications`}
          badge={unreadCount}
        />
        <MenuItem
          icon="settings"
          label={t('menu.settings')}
          route={`${ROUTES.DASHBOARD}/settings`}
        />
      </div>
    </nav>
  );
};

export default MainMenu; 